export default "__VITE_ASSET__7d10f6e5__"